import type React from 'react';

import * as styles from './styles';
import { title } from './constants';
import Link from '@material-ui/core/Link';

import { AddIcon, BodyText, DescriptionTitle, Divider, Heading1, PanelTab, PanelTabs } from '@cobliteam/base-components';

import { Button, Page } from '@cobliteam/ui/components';

import InfoRoundedIcon from '@mui/icons-material/InfoRounded';

import { TabPanelOptions } from '../../constants';

export interface ChecklistsHeaderProps {
  onTabPanelClick?: (tabPanelOption: TabPanelOptions) => void;
  selectedPanel?: TabPanelOptions;
  onButtonClick: () => void;
  isEmptyState?: boolean;
}

export const ChecklistsHeader: React.FC<ChecklistsHeaderProps> = ({ selectedPanel, onTabPanelClick, onButtonClick, isEmptyState = false }) => {
  return (
    <>
      <Page.Header>
        {isEmptyState ? (
          <div className={styles.emptyStateTitle}>
            <Heading1>Checklists</Heading1>
          </div>
        ) : (
          <PanelTabs value={selectedPanel} onChange={(_, tabPanelOption) => onTabPanelClick?.(tabPanelOption)}>
            <PanelTab disableRipple value={TabPanelOptions.RECEIVED_LISTS} label={title[TabPanelOptions.RECEIVED_LISTS]} />
            <PanelTab disableRipple value={TabPanelOptions.CREATED_LISTS} label={title[TabPanelOptions.CREATED_LISTS]} />
          </PanelTabs>
        )}

        <Button size='condensed' startIcon={<AddIcon />} className='min-w-40' onClick={onButtonClick}>
          Criar checklist
        </Button>
      </Page.Header>

      {isEmptyState ? (
        <div className={styles.listInfo}>
          <BodyText>
            As Checklists são
            <DescriptionTitle> formulários personalizados </DescriptionTitle>
            que ajudam a eliminar papéis e padronizar os processos do dia a dia da operação. Crie, aqui no painel, modelos de Checklists com diferentes tipos de resposta e, ao
            publicá-las, elas
            <DescriptionTitle> ficam disponíveis </DescriptionTitle>
            para preenchimento no
            <DescriptionTitle> app Cobli Motorista.</DescriptionTitle>
            <br />
            <br />
            Exemplos de Checklists que você pode criar:&nbsp;
            <DescriptionTitle>vistoria de entrada e saida, manutenção, conferência de equipamentos e instruções de serviços</DescriptionTitle>.
          </BodyText>
        </div>
      ) : (
        <div className={styles.headingWrapper}>
          <div className={styles.headingAndLearnMoreButton}>
            <Heading1>{selectedPanel && title[selectedPanel]}</Heading1>
            <Link href='https://suporte.cobli.co/pt-BR/articles/4984826-listas-checklists' target='_blank' rel='noopener' underline='none' className={styles.learnMoreButton}>
              <InfoRoundedIcon className={styles.learnMoreIcon} />
              Saiba mais
            </Link>
          </div>
          <div className={styles.divider}>
            <Divider />
          </div>
          {selectedPanel === TabPanelOptions.CREATED_LISTS && (
            <BodyText className={styles.bodyText}>
              Crie checklists personalizadas de acordo com seus objetivos – após publicá-las, elas estarão disponíveis para preenchimento no app
              <DescriptionTitle> Cobli Motorista.</DescriptionTitle>
            </BodyText>
          )}
        </div>
      )}
    </>
  );
};

export default ChecklistsHeader;
